import { ChangeDetectionStrategy, Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { IKeyMetricSettingsComponent, KeyMetricsSettingsBaseMixin } from '../key-metrics-settings.mixin';
import { ISiteMonitoringKeyMetricHideOkSettings } from '../../../../../model/key-metrics/site-monitoring-key-metric-hide-ok-settings.interface';
import { UntypedFormBuilder } from '@angular/forms';

@Component({
  selector: 'amp-key-metrics-hide-ok-settings',
  templateUrl: './key-metrics-hide-ok-settings.component.html',
  styleUrls: ['./key-metrics-hide-ok-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ['settings'],
  outputs: ['settingsChanged'],
  providers: [
    {
      provide: IKeyMetricSettingsComponent,
      useExisting: forwardRef(() => KeyMetricsHideOkSettingsComponent),
    },
  ],
})
export class KeyMetricsHideOkSettingsComponent extends KeyMetricsSettingsBaseMixin<ISiteMonitoringKeyMetricHideOkSettings>() implements IKeyMetricSettingsComponent, OnInit, OnDestroy {

  constructor(private _formBuilder: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.form = this._formBuilder.group({ hideKeyMetricOnOk: [!!this.settings?.hideKeyMetricOnOk] });
  }

  ngOnDestroy(): void {
    // unsubscribe all subscriptions
    this.onDestroy();
  }
}
